module.exports = __webpack_public_path__ + "media/images/grade-badge-d-a2aac582cebfc701cc717f56fd6799fe.svg";